<template>
  <div class="dogoodsWrapper">

         <div class='noDogoodsBtn' v-if="isDoGood"   @click='good("del")'>
           <span class='icon-love2'></span>已赞({{thumbCount}})</div>
     <div class='dogoodsBtn' v-else @click='good("add")'>
       <span class='icon-love'></span>点赞({{thumbCount}})</div>


 </div>
</template>
<script type = "text/ecamscript-6">
export default {
  name:"doGood",
  props:['thumbCount','isDoGood','goodID','openID','getThumbs','updataThumbOpenid'],
  created(){
  },
  methods:{
    good(opreation){
      console.log(typeof this.isDoGood,this.openID)
      this.$ajax.autoService.
      login("api/sendGiftGood.php?goodid="+this.goodID+"&thumbopenid="+this.openID+"&operation="+opreation).then(
        (res)=>{

          if (opreation == 'add') {
          //this.thumbOpenid = this.openID
          this.$emit('updataThumbOpenid',this.openID,0)
          this.getThumbs(1)
        } else {
          //this.thumbOpenid = null
          //this.isDoGood = this.thumbOpenid;
          this.$emit('updataThumbOpenid',null,-1,1)
          //this.thumbCount = this.thumbCount - 1
          // var thumbsTemp = []
          // for (var i = 0; i < temp.thumbs.length; i++) {
          //   if (temp.thumbs[i].thumbopenid != that.data.userOpenid) {
          //     thumbsTemp.unshift(temp.thumbs[i])
          //   }
          // }
          //temp.thumbs = thumbsTemp
        }
        }
      )
    }
  },
  computed:{
    // isDoGood:function(){
    //   return
    // }

  }
}
</script>
<style  lang="stylus">
  .dogoodsBtn
    border: 1px solid #f40
    /*px*/
    width: 280px
    height: 80px
    line-height: 80px
    color: #f40
    border-radius: 40px
    font-size: 28px
    margin: 40px auto 0
    text-align:center
  .noDogoodsBtn
    border: 1px solid #ccc
    /*px*/
    width: 280px
    height: 80px
    line-height: 80px
    color: #ccc
    border-radius: 40px
    font-size: 28px
    margin: 40px auto 0
    text-align:center
</style>



// WEBPACK FOOTER //
// src/components/userCenter/mall/doGood.vue